<template>
  <el-dialog :title="customerserial+'  '+deptname+'  '+mytitle" :visible.sync="dialogFormVisible" custom-class="full-dialog" center :append-to-body="true"
             :close-on-click-modal="false" @close="onDialogClose">
    <div class="search-content write-order">
      <el-row>
        <!--@keyup.enter.native="bindGrid"-->
        <el-col :span="24" class="toobar">
          <el-col :span="5">
            <AutoCustomer ref="autocustomer" @handleSelect="select" :splitByAddress="true" :needfocus="true"></AutoCustomer>
          </el-col>
          <el-col :span="9">
            <!--<el-button type="primary" @click="showdailog('86e6612f-4c47-4ac8-8758-75a8071c5245')">点我测试</el-button>-->
            <span style="float: left;margin-top: 0px;font-size:11pt;margin-left: 20px" v-if="customerserial">
              <!--门店：<span>{{deptname}}&nbsp;{{customerserial}}</span>-->
<template v-if="yuejiehu">    联系方式：<el-input v-model="elinkman" @change="changeAddress()" auto-complete="off" style="width: 80px" size="mini" placeholder="姓名"></el-input><el-input @change="changeAddress()" v-model="elinkmantel" placeholder="电话" auto-complete="off" style="width: 120px" size="mini"></el-input> <el-tag  :key="tag"  v-for="tag in this.ticket?this.ticket.split(';'):[]" :disable-transitions="false" size="mini" style="margin-left: 10px">{{tag}}</el-tag>
            </template>
              <template v-else>
                联系方式：{{elinkman}} {{elinkmantel}}<el-tag  :key="tag"  v-for="tag in this.ticket?this.ticket.split(';'):[]" :disable-transitions="false" size="mini" style="margin-left: 10px">{{tag}}</el-tag>
            </template>
                <br>
              收货地址：<el-input v-model="deliveryaddress" @change="changeAddress()" auto-complete="off" style="width: 400px" size="mini" placeholder="地址"></el-input>
            </span>
          </el-col>
          <el-col :span="4">
            <el-select v-model="cangkucode" @change="changeCangKu" size="mini" v-if="customerserial" style="width: 130px;display: block;margin: auto;float: left;margin-left: 30px;">
              <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                         :label="item.cangkuname"
                         :value="item.cangkucode">
              </el-option>
            </el-select>
            <div :style="{color:linecredit<0?'red':'blue'}" style="float: left;margin-top: 0px;font-size:11pt;margin-left: 20px" v-if="linecredit&&linecredit!=0">
              信用额度：{{linecredit}}
            </div>
          </el-col>
          <el-col :span="6">
            <el-drawer v-if="cashbalance>0" :withHeader="false" :modal="false" title="现金券" :visible.sync="supplydrawer" :wrapperClosable="true" :append-to-body="true" :direction="'rtl'">
              <el-table
                :data="cashbalancelist"
                size="mini"  :height="tableHeight(-60)"
                stripe
                border
                style="width: 100%;">
                <el-table-column
                  label="内容" prop="title"
                  align="left"
                  header-align="center" >
                </el-table-column>
                <el-table-column
                  label="余额"
                  align="left" width="140px"
                  header-align="center">
                  <template slot-scope="scope">
                    {{parseFloat(scope.row.money-scope.row.handleovermoney).toFixed(2)}}<br><span style="color: #9B9B9B;font-size: smaller">面额：{{scope.row.money}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="日期" prop="adddate"
                  align="left" width="90px"
                  header-align="center">
                </el-table-column>
              </el-table>
            </el-drawer>
            <div>
              <!--<el-button @click="showdailog('98e78d69-fc37-4c81-97c5-a7668948fb9f')"  type="success" style="margin-right: 0px;margin-left: 20px" size="mini" icon="el-icon-trophy">测试</el-button>-->
              <el-button @click="receive" v-if="customerserial&&isChuna&&yuejiehu" type="success" style="margin-right: 0px;margin-left: 20px" size="mini" icon="el-icon-trophy">收款</el-button>
              <el-button @click="receivecash" v-if="customerserial&&isChunaCongZ&&xianjinghu" type="success" style="margin-right: 0px;margin-left: 10px" size="mini" icon="el-icon-s-check">充值</el-button>

              <el-button @click="shoppingList" type="warning"  style="margin-right: 10px;margin-left: 10px" size="mini" icon="el-icon-shopping-cart-full">购物车</el-button>
              <el-button v-if="scantype == 'ai'" @click="continueAI" type="primary" style="margin-right: 10px;margin-left: 10px" size="mini" icon="el-icon-arrow-left">继续识别</el-button>
              <template v-if="customerserial">
              <br>
              <div :style="{color:yinshou>0?'red':'black'}" style="float: left;margin-top: 0px;font-size:11pt;margin-left: 20px">应收：{{showlookprice?yinshou:'???'}}</div>
              <div :style="{color:balance>0?'blue':'black'}" style="float: left;padding-left: 10px">余额：{{showlookprice?balance:'???'}}</div>
              <div :style="{color:cashbalance>0?'blue':'black'}" style="float: left;cursor: pointer;padding-left: 10px" @click="supplydrawer=true">现金券：{{showlookprice?cashbalance:'???'}}</div>
              </template>
            </div>
          </el-col>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <iframe width=100% scrolling="Auto" :height="tableHeight(142)" frameborder="0" name="writeorder"></iframe>
        </el-col>
      </el-row>
    </div>
    <HsCstagreementList ref="HsCstagreementList"></HsCstagreementList>
    <CstagreementEdit ref="orderShowcontent"></CstagreementEdit>
    <Shoppingsub ref="Shoppingsub1" @afterSelectShop="afterSelectShop"></Shoppingsub>
    <rechargeRecord4Chuna ref="rechargeRecord4Chuna1"  @bindGrid="afterrecharge"></rechargeRecord4Chuna>
    <ReceivablesEdit ref="ReceivablesEdit1" @reflash="afterreceive" :simpleedit="true"></ReceivablesEdit>
    <rechargeRecordAdd ref="rechargeRecordAdd1" @bindGrid="afterrecharge" :customername="deptname" :simpleedit="true"></rechargeRecordAdd>
  </el-dialog>
</template>

<script>
  import {independentDept} from '@/api/set/dept';
  import CstagreementEdit from './CstagreementEdit';
  import Shoppingsub from './Shoppingsub';
  import {simulationLogin,webPath,checkModuleRight} from '@/api/login';
  import {listCash} from '@/api/set/machinecoupon';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {getDuiZhangCus,customerBalance} from '@/api/voucher/accountresultbz';
  import HsCstagreementList from './HsCstagreementList';
  import rechargeRecord4Chuna from '@/components/set/recharge/rechargeRecord4Chuna';
  import ReceivablesEdit from '@/components/voucher/ReceivablesEdit';
  import rechargeRecordAdd from '@/components/set/recharge/rechargeRecordAdd';

  export default {
    inject: ["afterCloseDialog"],
    name: 'WriteOrder',
    data() {
      return {
        activeIndex: '1',
        supplydrawer:false,
        fengongscangku:false,
        xianjinghu:false,
        yuejiehu:false,
        msg: '代客下单',
        dialogFormVisible: false,
        searchdata: "",
        myunitgroup: this.unitgroup,
        mytitle: this.title,
        loading: true,
        servedserial: "",
        idd: [],
        tableData: [],
        showlookprice:false,
        pinyinData: [],
        isChuna:true,
        isChunaCongZ:true,
        coupon: '',
        province: '',//省
        city: '',//市
        county: '',//县
        linecredit:'',
        setlinecredit:0,
        yinshou:0.00,
        balance:0.00,
        cashbalance:0.00,
        cashbalancelist:[],
        couponServedserial: '',//独立核算
        deliveryaddress: '',//收货地址
        deptname: '',
        ticket:'',
        loginName: '',
        customerserial: '',
        restaurants: [],
        timeout: null,
        elinkman: '',
        elinkmantel: '',
        jxcstoreData: [],//仓库数组
        cangkucode: '',//选中的仓库
        settingmenthod:'',
        scantype:'',
        frameopenURL:'',
        myToken: '',//选中客户后记录的 token（多窗口防串客户：检测到 token 变了就关闭开单窗口）
        sessionCheckTimer: null,//防串客户轮询定时器（关闭对话框时注销）
      }
    },
    props: {
      unitgroup: {
        default: 1
      },
      title: {
        default: "客户信息"
      },
      parentcustomerserial: {//上级客户编码
        default: ""
      },
      filterbyservedserial: {//根据当前登录人所属的加工中心过滤数据
        default: false
      },
      storeInfo: {
        default: ""
      }
    },
    methods: {
      setCangkuName(){
        for (let j in  this.jxcstoreData) {
          if (this.cangkucode == this.jxcstoreData[j].cangkucode) {
            localStorage.setItem('cangkuname', this.jxcstoreData[j].cangkuname);
            break;
          }
        }
      },
      changeCangKu() {
        localStorage.setItem('cangkucode', this.cangkucode);
        this.setCangkuName();
        try {
          window.writeorder.window.refreshErWeiTable()
        } catch (ee) {
        }
      },
      afterSelectShop(row) {
        this.$refs.autocustomer.initCus(row.customerserial);
      },
      //客户地址
      select(customerserial, customername, row) {
        this.settingmenthod = ''
        this.deliveryaddress = row.deliveryaddress
        this.elinkman = row.linkman
        this.elinkmantel = row.linkmantel
        this.deptname = row.deptname
        this.ticket = row.ticket
        this.customerserial = row.customerserial
        this.xianjinghu=false;
        this.yuejiehu=false;
        var settingmenthods = row.settingmenthod.split(',');
        for (let i = 0; i < settingmenthods.length; i++) {
          if (settingmenthods[i] == '全额现结' || settingmenthods[i] == '100') {
            settingmenthods[i] = 100
            this.xianjinghu = true;
          } else if (settingmenthods[i] == '月结' || settingmenthods[i] == '200') {
            settingmenthods[i] = 200
            this.yuejiehu = true;
          }
          if (this.settingmenthod) {
            this.settingmenthod = this.settingmenthod + ',' + settingmenthods[i]
          } else {
            this.settingmenthod = settingmenthods[i] + ''
          }
        }
        var initCangKu=row.servedserial;
        if(this.jxcstoreData.length>0) {
          this.cangkucode = this.jxcstoreData[0].cangkucode;
          if (this.fengongscangku) {
            for (let i in this.jxcstoreData) {
              if (this.jxcstoreData[i].independentserial == initCangKu) {
                this.cangkucode = this.jxcstoreData[i].cangkucode;
                break;
              }
            }
          }
          this.changeCangKu();
        }
        //客户信息
        simulationLogin({loginName: this.loginName, customerserial: this.customerserial}).then(response => {
          if (response.data.code == 0) {
            localStorage.setItem('hpweb_token', response.data.token); //兼容vue端的相关页面
            localStorage.setItem('keFTtoken', response.data.token); //token
            localStorage.setItem('keFuInfoModel', JSON.stringify(response.data.obj)); //用户信息
            localStorage.setItem('domain', webPath());
            localStorage.setItem('deliveryaddress', this.deliveryaddress);
            localStorage.setItem('memberdounitguid', response.data.obj.memberDO.unitguid);
            localStorage.setItem('elinkman', this.elinkman);
            localStorage.setItem('elinkmantel', this.elinkmantel);
            localStorage.setItem('cangkucode', this.cangkucode);
            this.setCangkuName();
            localStorage.setItem('settingmenthod', this.settingmenthod);
            //记录本次选中客户的 token：其他窗口选了别的客户会覆盖全局 localStorage，
            //切回本窗口时一旦发现 token 不一致就关闭当前开单窗口，避免串客户下单
            this.myToken = response.data.token;
            // if (this.settingmenthod.indexOf("100")>-1) {//现金支付
            if (this.scantype == 'scan') {
              this.scanPackages();
            } else if (this.scantype == 'ai') {
              // AI开单 - 跳转到LensQuickOrder页面（时间戳放hash前强制刷新
              localStorage.setItem('cangkuname', localStorage.getItem('cangkuname') || '');
              window.open(window.location.origin + '/?t=' + Date.now() + '#/app/LensQuickOrder', 'writeorder', false)
            } else {
              window.open(window.location.origin + "/H5/html/gouWuChe/gouWuChe.html?time=20210928", 'writeorder', false)
            }
          } else {
            this.$message({
              type: 'warning',
              duration: 1500,
              message: response.data.msg
            });
          }
        })
        this.setlinecredit = row.linecredit;
        this.afterreceive();
        this.afterrecharge();
      },
      changeAddress(){
        localStorage.setItem('deliveryaddress', this.deliveryaddress);
        localStorage.setItem('elinkman', this.elinkman);
        localStorage.setItem('elinkmantel', this.elinkmantel);
      },
      //【多窗口防串客户】每 1 秒检测一次全局 token：若已被其他页面改写（选了别的客户），
      //直接关闭当前开单窗口，避免客服继续用错误的客户下单
      startSessionCheck() {
        this.stopSessionCheck();
        var self = this;
        var check = function () {
          if (!self.dialogFormVisible) {//对话框已关闭，停止检测
            self.sessionCheckTimer = null;
            return;
          }
          if (self.myToken && localStorage.getItem('hpweb_token') !== self.myToken) {
            self.$message({
              type: 'warning',
              duration: 3000,
              message: '检测到客户已在其他页面切换，当前开单窗口已关闭，请重新选择客户'
            });
            self.dialogFormVisible = false;
            self.sessionCheckTimer = null;
            return;
          }
          self.sessionCheckTimer = setTimeout(check, 1000);
        };
        this.sessionCheckTimer = setTimeout(check, 1000);
      },
      stopSessionCheck() {
        if (this.sessionCheckTimer) {
          clearTimeout(this.sessionCheckTimer);
          this.sessionCheckTimer = null;
        }
      },
      onDialogClose() {
        this.stopSessionCheck();
        this.afterCloseDialog();
      },
      recharge(){
        this.$refs.rechargeRecord4Chuna1.show(this.customerserial, this.deptname)
      },
      afterrecharge() {
        this.balance = 0.00;
        customerBalance({customerserial: this.customerserial}).then(resCredit => {
          if (resCredit.data.code == 0) {
            this.balance = parseFloat(resCredit.data.obj).toFixed(2);//可用余额
          }
        })

        this.cashbalance = 0.00;
        listCash({customerserial: this.customerserial, type: 3}).then(resCredit => {
          if (resCredit.data.code == 0) {
            this.cashbalancelist = resCredit.data.obj;//现金券
            for (let i in this.cashbalancelist) {
              this.cashbalance += parseFloat(this.cashbalancelist[i].money) - parseFloat(this.cashbalancelist[i].handleovermoney);
            }
            this.cashbalance = this.cashbalance.toFixed(2);
          }
        })
      },
      receive(){
        this.$refs.ReceivablesEdit1.show('收款',{customerserial: this.customerserial,customername:this.deptname,totalmoney:0})
      },
      receivecash(){
        this.$refs.rechargeRecordAdd1.initForm()
        this.$refs.rechargeRecordAdd1.show(this.customerserial,this.deptname);
      },
      shoppingList(){
        this.$refs.Shoppingsub1.show()
      },
      continueAI() {
        window.open(window.location.origin + '/?t=' + Date.now() + '#/app/LensQuickOrder', 'writeorder', false)
      },
      afterreceive() {
        this.linecredit = '';
        this.yinshou = 0.00;
        getDuiZhangCus({customerserial: this.customerserial,needyinshou:'true'}).then(resCredit => {
          if (resCredit.data.code == 0) {
            var useMoney = parseFloat(resCredit.data.obj);//已使用金额
            this.yinshou = useMoney.toFixed(2);

            if (this.setlinecredit && this.setlinecredit > 0) {
              this.linecredit = (parseFloat(this.setlinecredit) - useMoney).toFixed(2);
            }
          }
        })
      },
      scanPackages() {//打开扫光度码的页面
        this.frameopenURL = this.frameopenURL=='HsScanlens'?"HsScanlensV2":"HsScanlens";
        window.open(window.location.origin + "/#/app/" + this.frameopenURL, 'writeorder', false)
      },
      showdailog(groupguid) {
          this.$refs.HsCstagreementList.bindGrid(groupguid)
      },
      showdailogOrder(erpserial) {
        this.$refs.orderShowcontent.initData({erpserial:erpserial})
        this.$refs.orderShowcontent.show()
      },
      show(unitgroup, title,scantype) {
        this.cangkucode = ''//选中的仓库
        this.searchdata = ''//选中的门店
        this.customerserial='';
        this.deptname='';
        this.deliveryaddress = ''//收货地址
        this.linecredit=''
        this.yinshou=0.00;
        this.balance=0.00;
        this.cashbalance=0.00;
        this.restaurants = []
        this.pinyinData = []
        this.coupon = ''
        this.province = ''//省
        this.city = ''//市
        this.county = ''//县
        this.scantype=scantype
        this.couponServedserial = ''//独立核算
        this.myToken = ''//清空上次记录的 token，选中客户后重新记录
        this.startSessionCheck();//开始每秒检测全局 token 是否被其他页面改写
        if (unitgroup) {
          this.myunitgroup = unitgroup
        }
        if (title) {
          this.mytitle = title
        }
        this.dialogFormVisible = true
        if (this.storeInfo) {
          this.coupon = this.storeInfo.coupon
          this.province = this.storeInfo.province//省
          this.city = this.storeInfo.city//市
          this.county = this.storeInfo.county//县
          this.couponServedserial = this.storeInfo.independentserial//独立核算
        }
        if (this.$refs.autocustomer)
          this.$refs.autocustomer.init();
        this.cusandptbyind();
      },
      cusandptbyind() {
        //根据登录人过滤仓库
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj
          //默认仓库
          if (this.userInfoModel.cangku) {
            let temp1 = this.userInfoModel.cangku.split(";")
            biaoji:
              for (let i in temp1) {
                for (let j in  this.jxcstoreData) {
                  if (temp1[i] == this.jxcstoreData[j].cangkucode) {
                    this.cangkucode = temp1[i]
                    break biaoji;
                  }
                }
              }

          } else {
            this.cangkucode = this.jxcstoreData[0].cangkucode
          }
        })

      },
    },
    mounted() {
      window.showdailog = (groupguid) => {
        this.showdailog(groupguid)
      }
      window.showdailogOrder = (erpserial) => {
        this.showdailogOrder(erpserial)
      }
      checkModuleRight({name: 'fengongscangku'}).then(reponse => {
        this.fengongscangku = reponse.data.code == 0;
      });
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.showlookprice=(this.userInfoModel.myright.indexOf('|财务|') != -1 || this.userInfoModel.myright.indexOf('|查看订单价格|') != -1);
      this.isChuna=this.userInfoModel.myright.indexOf('|代下单-收银|') > -1;
      this.isChunaCongZ=this.userInfoModel.myright.indexOf('|代下单-充值|') > -1;
      this.servedserial = this.userInfoModel.independentserial;
      //默认值
      if (!this.userInfoModel.independentserial) {
        independentDept().then(response => {
          this.idd = response.data.obj
          if (this.userInfoModel.independentserial == "") {
            this.idd.unshift({serialnum: "all", dname: "全部"})
            this.servedserial = 'all';
          }

        })
      }
    },
    beforeDestroy() {
      this.stopSessionCheck();
    },
    components: {
      HsCstagreementList,
      rechargeRecord4Chuna,
      ReceivablesEdit,
      rechargeRecordAdd,
      CstagreementEdit,
      Shoppingsub
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/


</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/WriteOrder.vue